import { useContext } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as ArrowSelect } from 'assets/arrow-select.svg';
import i18nContext from 'components/i18n-context';
import './EmailStatisticsTableHead.scss';

export const EMAIL_STATISTICS_TABLE_HEADER = [
  {
    label: 'customerNumber',
    sortBy: 'customerNumber'
  },
  {
    label: 'email',
    sortBy: 'email'
  },
  {
    label: 'templateName',
    sortBy: 'templateName'
  },
  {
    label: 'status',
    sortBy: 'status'
  },
  {
    label: 'sentAt',
    sortBy: 'createdAt'
  }
];

const EmailStatisticsTableHead = ({ handleOnSortTable, sortBy, direction }) => {
  const i18n = useContext(i18nContext);

  return (
    <tr>
      {EMAIL_STATISTICS_TABLE_HEADER.map(
        (head) =>
          head.label && (
            <th key={head.label} className={'email-statistics-table-head'}>
              <div className={'email-statistics-table-head-block'}>
                <span>{i18n.getMessage(`emailStatistics.table.header.${head.label}`)}</span>
                {head.sortBy && (
                  <ArrowSelect
                    onClick={() => handleOnSortTable(head.sortBy)}
                    className={`email-statistics-sorting-arrow-icon ${sortBy === head.sortBy && direction}`}
                  />
                )}
              </div>
            </th>
          )
      )}
    </tr>
  );
};

EmailStatisticsTableHead.propTypes = {
  handleOnSortTable: PropTypes.func,
  sortBy: PropTypes.string,
  direction: PropTypes.string
};

export default EmailStatisticsTableHead;
